<p-dialog
    [attr.aria-label]="'global.search.placeholder' | artemisTranslate"
    [visible]="overlay.isOpen()"
    (visibleChange)="$event ? overlay.open() : overlay.close()"
    (onHide)="overlay.close()"
    (onShow)="focusInput()"
    [modal]="true"
    [closable]="true"
    [showHeader]="false"
    [closeOnEscape]="false"
    [dismissableMask]="true"
    contentStyleClass="p-0 flex flex-col h-full overflow-hidden"
    position="center"
    styleClass="global-search-dialog"
>
    <!-- Search Input Container -->
    <jhi-global-search-input
        [searchQuery]="searchQuery()"
        [activeFilters]="activeFilters()"
        [courseFilterLabel]="activeCourseLabel()"
        [isLoading]="isLoading()"
        (searchInput)="onSearchInput($event)"
        (filterRemoved)="removeFilter($event)"
        (courseFilterRemoved)="removeCourseFilter()"
        (backspaceOnEmpty)="onBackspaceRemoveFilter()"
    />
    <!-- Results Area -->
    <div class="results-container">
        @switch (currentView()) {
            @case (SearchView.Navigation) {
                @if (overlay.isOpen()) {
                    <jhi-global-search-navigation-view
                        [searchQuery]="searchQuery()"
                        [selectedIndex]="selectedIndex()"
                        [results]="results()"
                        [hasSearched]="hasSearched()"
                        [showResults]="showResults()"
                        [isLoading]="isLoading()"
                        [searchError]="searchError()"
                        [activeFilters]="activeFilters()"
                        (viewSelected)="navigateTo($event)"
                        (entityClick)="onEntityClick($event)"
                    />
                }
            }
            @case (SearchView.Lecture) {
                <jhi-global-search-lecture-results (back)="navigateTo(SearchView.Navigation)" [searchQuery]="searchQuery()" [selectedIndex]="selectedIndex()" />
            }
        }
    </div>
    <!-- Keyboard hints footer -->
    <div class="search-footer shrink-0 text-start">
        <div class="keyboard-hints flex items-center justify-between text-muted-color w-full gap-3">
            <span class="flex items-center gap-1">
                <span class="flex items-center gap-1">
                    <kbd class="key-hint-small inline-flex items-center font-mono text-muted-color border" [attr.aria-label]="'global.search.arrowUpAriaLabel' | artemisTranslate">
                        <fa-icon [icon]="faArrowUp" aria-hidden="true" />
                    </kbd>
                    <kbd
                        class="key-hint-small inline-flex items-center font-mono text-muted-color border"
                        [attr.aria-label]="'global.search.arrowDownAriaLabel' | artemisTranslate"
                    >
                        <fa-icon [icon]="faArrowDown" aria-hidden="true" />
                    </kbd>
                </span>
                <span class="ms-2">{{ 'global.search.toNavigate' | artemisTranslate }}</span>
            </span>
            <span class="flex items-center gap-1">
                <kbd class="key-hint-small inline-flex items-center font-mono text-muted-color border" aria-label="Escape">ESC</kbd>
                <span class="ms-2">{{ 'global.search.toClose' | artemisTranslate }}</span>
            </span>
        </div>
    </div>
</p-dialog>
